module.exports = {
    // 獲取驗證碼
    getVerificationCode: 'kaihu/getVerificationCode',
    // 登錄接口
    register: 'kaihu/register',
    // 點擊同意協議
    // register : 'kaihu/register',
    // 開戶類型提交
    newkhlx: 'kaihu/newkhlx',
    // 基本信息提交
    newjbxx: 'kaihu/newjbxx',
    // 受僱狀況提交
    newsgzk: 'kaihu/newsgzk',
    // 財務狀況提交
    newcwzk: 'kaihu/newcwzk2',
    // 客戶聲明提交
    newkhsm: 'kaihu/newkhsm2',
    // 客戶聲明提交
    newfxpg: 'kaihu/newfxpg2',
    // 文件上傳提交
    newwjsc: 'kaihu/newwjsc',
	
	newbktzh: 'kaihu/newwebktzh',
    // 預約開戶提交
    newktzh: 'kaihu/newktzh',
    // 財務狀況歷史數據查詢
    getWEBMsg: 'kaihu/getWEBMsg',
    // 
    getYuYueTimeList: 'kaihu/getYuYueTimeList',
    //圖片上傳
    uploadPic: 'kaihu/uploadPic',
	//
	newWebYuyue: 'kaihu/newWebYuyue',
    //开户书第一部分
	getAgreeMentOfKHPage: 'groupweb/getAgreeMentOfKHPage',
    // 节假日获取
	getHolidayList: 'kaihu/getHolidayForWebsite',
    // 翻译
	getTargetText: 'kaihu/getTargetText',
    // 常见问题
	getKHFAQ: 'groupweb/getKHFAQ',

}